import { getInsightsDates } from '../helpers/getInsightsDates'

export const INSIGHTS_DATES = getInsightsDates()
